/** Utilidades de acceso al DOM. */

import { renderIcons } from "./icons";

/** Obtiene un elemento por id y falla con mensaje claro si no existe. */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Elemento #${id} no encontrado en el DOM`);
  return el as T;
}

/** Intenta obtener un elemento sin lanzar error. */
export function optionalById<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

/** Vuelve a renderizar los iconos Lucide (auto-hospeados, seguro en cada render). */
export function refreshIcons(): void {
  renderIcons();
}

/** Elementos [data-nav] activos → aria-current + clases de navegación. */
export function markActiveNav(viewId: string): void {
  document.querySelectorAll<HTMLElement>("[data-nav]").forEach((el) => {
    const active = el.getAttribute("data-nav") === viewId;
    el.classList.toggle("active", active);
    if (el.closest("nav")) {
      if (active) el.setAttribute("aria-current", "page");
      else el.removeAttribute("aria-current");
    }
  });
}

/** Lleva el scroll al inicio (respetando prefers-reduced-motion). */
export function scrollToTop(): void {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: 0, behavior: reduced ? "auto" : "smooth" });
}
